





































































































































































































































































































































































import _ from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import router from "@/router";
// import { Messaging } from 'firebase/messaging';
import { Workbox } from 'workbox-window'

import AvatarMenu from "@/components/AvatarMenu.vue"; // @ is an alias to /src
// import Notifications from "@/components/Toolbar/Notifications.vue";
import Messages from "@/components/Toolbar/Messages.vue";
import LandingPage from "@/views/LandingPage.vue";
// import Home from "@/views/Home.vue";
import PrintPupilsQrCodes from "@/components/SchoolClasses/PrintPupilsQrCodes.vue";
// import Gdpr from "@/views/Gdpr.vue";
// interfaces
import { PortalUserVM, SchoolVM, SchoolClassVM, SelectListItem } from "@/interfaces/PortalUserVM";
import rest from "./rest";

const auth = namespace("auth");
const ux = namespace("ux");
const globals = namespace("globals");
const notify = namespace("notify");

@Component({
  components: {
    AvatarMenu,
    Messages,
    LandingPage,
    PrintPupilsQrCodes,
  }
})
export default class App extends Vue {
  @globals.Getter isInPrintMode!: boolean;
  @globals.Getter showPrintPupilsQrCode!: boolean;

  agreeToGdpr = false;
  showGdprDlg = false;
  showUpdateAvailable = false;
  showLogout = false;
  workbox: any = null;

  $refs!: {
    aMenu: HTMLElement;
  };

  rtviewkey: number = 5000;
  drawer: boolean = false;
  viewIndex: number = 0;
  showAppName: boolean = true;

  // defaultUser: PortalUserVM = {
  //   id: "0",
  //   firstName: "",
  //   lastName: "",
  //   nickname: "",
  //   fullName: "",
  //   userName: "",
  //   email: "",
  //   disabled: false,
  //   selectRoles: [] as SelectListItem[],
  //   roles: [],
  //   showMenu: false,
  //   selected: false,
  //   avatar: "",
  //   disableAvatar: false,
  //   gdprApprovalDate: null,
  //   gdprApprovalRequired: false,
  //   activationKey: "",
  //   schoolId: 0,
  //   schoolClassId: 0,
  //   schools: [] as SchoolVM[],
  //   classLeaderOf: [] as SchoolClassVM[],
  //   schoolClasses: [] as SchoolClassVM[]
  // };

  // testUserVm: PortalUserVM = _.cloneDeep(this.defaultUser);
  //views = this.$route.options.routes;

  @auth.Action Login: any;
  @auth.Getter isAdmin: any;
  @auth.Getter isContentManager: any;
  @auth.Getter isNotificationAdmin: any;
  @auth.Getter isPrincipal: any;
  @auth.Getter isTeacher: any;
  @auth.Getter isLearner: any;
  @auth.Getter isParent: any;
  @auth.Getter isPupil: any;
  @auth.Getter loginName!: string;
  @auth.Getter loggedIn!: boolean;
  @auth.Getter logoutTime!: number;

  @ux.Mutation COLORS_LIGHT: any;
  @ux.Mutation COLORS_DARK1: any;
  @ux.Mutation COLORS_DARK2: any;
  @ux.State darkTheme: any;

  @notify.Getter hasNewTopicNotifications: any;
  @notify.Getter newTopicNotificationCount: any;


  deferPwaPrompt: any = null;
  isStandalone = false;
  showInstallButton = false;

  async mounted() {
    this.checkIfAppIsStandalone();

    this.$nextTick(() => {
      this.init();
      this.COLORS_DARK2();
      this.$vuetify.theme.dark = this.darkTheme;
    });
  }

  destroyed() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener('beforeinstallprompt', this.deferPwaPromptCb);
  }

  created() {
    window.addEventListener("resize", this.onResize);

    // https://forum.quasar-framework.org/topic/2560/solved-pwa-force-refresh-when-new-version-released/56
    // https://developers.google.com/web/tools/workbox/guides/advanced-recipes#offer_a_page_reload_for_users
    if ('service-worker' in navigator) {
      this.workbox = new Workbox("/service-worker.js")

      this.workbox.addEventListener("waiting", (event) => {
        this.showUpdateAvailable = true;
      })
      this.workbox.register();
    }
  }

  // async registerFirebase() {
  //   await this.registerFcm();
  // }

  checkIfAppIsStandalone() {
    // console.log("addEventListener for beforeinstallprompt event");
    this.isStandalone = window.matchMedia('(display-mode: standalone)').matches; // For Android
    if (this.isStandalone) {
      console.log("Android standalone App detected");
    } else {
      this.isStandalone = (window.navigator as any)?.standalone === true; // For iOS
      if (this.isStandalone)
        console.log("iOS standalone App detected");
    }
    if (this.isStandalone)
      return;

    if (this.$globalHelper.isiOs) {
      this.showInstallButton = true;
    } else {
      window.addEventListener('beforeinstallprompt', this.deferPwaPromptCb);

      // Tracking Display Mode Transitions
      window.matchMedia('(display-mode: standalone)').addEventListener('change', ({ matches }) => {
          if (matches) {
              this.showInstallButton = false;
          } else {
              this.showInstallButton = true;
          }
      });
    }
  }

  deferPwaPromptCb(e: Event) {
    // console.log("defer PWA prompt event");

    e.preventDefault();
    this.deferPwaPrompt = e;
    this.showInstallButton = true;
  }

  async installApp() {
    if (!this.deferPwaPrompt) {
      console.log("Defer Pwa Prompt event not registered!");
      return;
    }

    this.deferPwaPrompt.prompt();
    let choiceResult = await this.deferPwaPrompt.userChoice;
    // console.log(choiceResult.outcome);
    if (choiceResult.outcome === "accepted") {
      this.deferPwaPrompt = null;
      this.showInstallButton = false;
    }
  }

  async onAgree() {
    let result = await rest.url("auth/agreeToGdpr").post();
      if (result == true) {
      this.$store.commit("ux/SB_SUCCESS", {
        message: "Zustimmung gespeichert",
        timeout: 3000
      });
    }
    // Update user
    let portalUser: PortalUserVM = await rest.url("Auth/getPortalUser").get();
    if (portalUser != null)
      this.$store.commit("auth/setPortalUser", portalUser);
  }

  @Watch("darkTheme")
  onThemeChanged (){
      this.$vuetify.theme.dark = this.darkTheme;
  }

  @Watch("drawer")
  onDrawerVisibilityChanged() {
     this.updateDrawerVisibility();
  }

  @Watch("$vuetify.breakpoint.mobile")
  onMobileBreakPointChanged() {
     this.updateDrawerVisibility();
  }

  @Watch("logoutTime")
  onLogoutTimeChanged() {
    if (!this.loggedIn) {
      this.showLogout = false;
      return;
    }
    this.showLogout = this.logoutTime > 0 && this.logoutTime <= 30;
  }

  get logoutTimeout() {
    if (this.logoutTime > 30)
      return 100;
    return this.logoutTime * 100 / 30;
  }

  updateDrawerVisibility() {
    if (!this.drawer)
      this.$store.commit("ux/ReserveSpaceForDrawer", false);
    else if (!this.$vuetify.breakpoint.mobile)
      this.$store.commit("ux/ReserveSpaceForDrawer", true);
  }

  updateApp() {
    if (!this.workbox) {
      window.location.reload();
      this.showUpdateAvailable = false;
      return;
    }
    this.workbox.addEventListener('controlling', () => {
      window.location.reload();
    })
   this.workbox.messageSkipWaiting();
  }

  onResize(event) {
    // this.updateDrawerVisibility();

    if (!this.$refs.aMenu)
      return;

    let avatarWidth = this.$refs.aMenu.offsetWidth;
    let windowWidth = window.innerWidth;
    // console.log(windowWidth);
    if (windowWidth - avatarWidth - 220 < 0)
      this.showAppName = false;
    else
      this.showAppName = true;
  }

  async init() {
    await this.Login();
    await this.$store.commit("ready");
  }

  refresh() {
    this.rtviewkey++;
  }

  goHome() {
    if (router.currentRoute.path == "/")
      return;
    router.push("/");
  }

  goToGdprPage() {
    router.push("/gdpr");
  }

  goToImprintPage() {
    router.push("/imprint");
  }

  goToTermsOfUsePage() {
    router.push("/termsOfUse");
  }

  get currentTheme() {
    return this.darkTheme;
  }

  set currentTheme(val) {
    // console.log(this.darkTheme);

    if (this.darkTheme)
      this.COLORS_LIGHT();
    else
      this.COLORS_DARK2();
  }

  // get currentThemeName() {
  //   return (this.darkTheme) ? 'dark' : 'light'
  // }

  get backgroundColor() {
    let currentThemeName = this.$vuetify.theme.dark ? 'dark' : 'light';
    return this.$vuetify.theme.themes[currentThemeName].appBackground;
  }

  get themeName() {
    return this.darkTheme ? "Dunkles Design" : "Helles Design";
  }

  get gdprApprovalRequired() {
    return this.$store.state.auth.portalUser?.gdprApprovalRequired ?? false;
  }

  public get snackbar() {
    let sb = this.$store.state.ux.snackbar;
    return sb;
  }

  public set snackbar(value) {
    this.$store.commit("ux/SB_UPDATE", value);
  }

  get snackbarColor() {
    return this.$store.state.ux.sbcontext;
  }

  get snackbarTimeout() {
    return this.$store.state.ux.sbtimeout;
  }
}
